import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Document, DocumentProject } from '../../../../generated/generated-types';
import { DocumentService } from '../../services/document.service';
import { DocumentAdvancePaymentsListWidgetComponent } from '../document-advance-payments-list-widget/document-advance-payments-list-widget.component';

@Component({
  selector: 'app-formly-document-advance-payments-list-widget',
  templateUrl: './formly-document-advance-payments-list-widget.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  imports: [DocumentAdvancePaymentsListWidgetComponent, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyDocumentAdvancePaymentsListWidgetComponent extends FieldType<FieldTypeConfig> implements OnInit {
  documentProject: DocumentProject;

  cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor(
    private documentService: DocumentService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.model) {
      this.documentProject = this.model?.documentProject;
    }

    this.formControl?.parent?.valueChanges.subscribe((doc: Document) => {
      let needsChangeDetection = false;
      if (this.documentProject?.id != doc.documentProject?.id) {
        this.documentProject = doc.documentProject;
        needsChangeDetection = true;
      }
      if (needsChangeDetection) {
        this.cdRef.markForCheck();
      }
    });
  }

  async onDocumentChanged() {
    if (this.model?.id)
      await this.documentService.refetchOnlyDocumentLineItemCausedChanges(this.model.id);
    this.cdRef.markForCheck();
  }
}
